import { TimelineMax, Power3 } from "gsap";
import Helpers from "../helpers";
export default class Header {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!element) return;

        this.learnMore = this.element.querySelector("#learn_more");
        this.sellBtn = this.element.querySelector(".header__link-btn");
        this.langDrop = this.element.querySelector(".header__lang-visual");
        this.langItems = this.element.querySelectorAll(
            ".header__lang-options-item"
        );
        this.selectedLang = this.element.querySelector(
            ".header__lang--selected"
        );
        this.jobSearchBtn = this.element.querySelector(
            "#workplace-jobs--scroll"
        );
        this.langOptions = this.element.querySelector("#header__lang--options");
        this.trigger = this.element.querySelector(".header__trigger");

        this.stripes = this.element.querySelectorAll(".stripe");

        this.navItems = this.element.querySelectorAll(
            ".header__navigation-item"
        );

        this.navLinks = this.element.querySelectorAll(
            ".header__navigation-link"
        );

        this.scrollLinks = document.querySelectorAll(
            ".scroll__navigation-link"
        );

        this.navSubMenu = this.element.querySelectorAll(
            ".header__navigation-submenu"
        );

        this.isOpen = false;

        this.joinUsLinks = document.querySelectorAll(".join-us_link");

        this.checkScroll();

        this.init();
    }

    init() {
        this.checkLocalStorageForScroll();
        this.bindEvents();
    }

    checkScroll() {
        // let target = document.cookie.match(
        //     "(^|;) ?" + "scroll" + "=([^;]*)(;|$)"
        // );

        // target = target ? target[2] : null;
        let hash = window.location.hash;
        if (hash) {
            let target = document.querySelector(hash);
            if (target) {
                console.log(target.getBoundingClientRect().top);
                window.scrollTo({
                    top: target.getBoundingClientRect().top
                });
            }
        }
        // if (target) {
        //     document.cookie =
        //         "scroll" + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        //     this.closeMenu().add(() => {
        //         Helpers.scrollTo(window.location, target, 0.8);
        //     });
        // }
    }

    bindEvents() {
        if (this.learnMore) {
            //Sell your brand
            if (window.location.pathname.includes("sell-your-brand")) {
                this.learnMore.addEventListener("click", e => {
                    e.preventDefault();
                    document.getElementById("elevate-section").scrollIntoView({
                        behavior: "smooth"
                    });
                });
            } else {
                //Homepage scroll na BBG is a pioneer
                this.learnMore.addEventListener("click", e => {
                    e.preventDefault();
                    document
                        .getElementById("who-we-are")
                        .scrollIntoView({ behavior: "smooth" });
                });
            }
        }

        if (this.langDrop) {
            this.langDrop.addEventListener("click", e => {
                this.langOptions.classList.toggle(
                    "header__lang-options--opened"
                );
            });
            this.langItems.forEach(item => {
                item.addEventListener("click", e => {
                    this.langItems.forEach(link => {
                        link.classList.remove("header__disabled");
                    });
                    this.selectedLang.innerText = e.target.innerText;
                    e.target.classList.add("header__disabled");
                });
            });
        }

        if (
            this.sellBtn &&
            !window.location.pathname.includes("workplaces") &&
            !window.location.pathname.includes("newsroom") &&
            !window.location.pathname.includes("privacy-policy") &&
            !window.location.pathname.includes("impressum") &&
            !window.location.pathname.includes("referral")
        ) {
            if (window.location.pathname.includes("sell-your-brand")) {
                this.sellBtn.addEventListener("click", e => {
                    e.preventDefault();
                    document.getElementById("contact-form").scrollIntoView({
                        behavior: "smooth"
                    });
                });
            }
        }

        if (this.joinUsLinks) {
            this.joinUsLinks.forEach(joinus => {
                joinus.addEventListener("click", e => {
                    e.preventDefault();
                    this.joinUsLinkRedirect(e);
                });
            });
        }

        this.trigger.addEventListener("click", e => {
            e.preventDefault();
            this.toggleMenu();
        });

        Helpers.forEach(this.navLinks, (index, item) => {
            item.addEventListener("click", e => {
                let target = e.currentTarget.getAttribute("data-scroll");

                e.preventDefault();

                let tl = new TimelineMax();

                this.closeMenu().add(() => {
                    if (target == "#brands") {
                        let el = document.querySelector("#brands");
                        el.scrollIntoView(true);
                        document.getElementById("brands").scrollTop -= 100;
                    } else {
                        document.querySelector(target).scrollIntoView({
                            behavior: "smooth"
                        });
                    }
                });
            });
        });

        Helpers.forEach(this.navSubMenu, (index, item) => {
            item.addEventListener("click", e => {
                e.preventDefault();

                let target = e.currentTarget.parentElement.querySelector(
                    ".header__navigation-dropdown"
                );

                target.classList.toggle("header__navigation-dropdown--active");
            });
        });
    }
    scrollToJobs(e) {
        e.preventDefault();

        const id = e.currentTarget.hash;
        const yOffset = -280;
        const element = document.querySelector(id);
        const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
    }

    toggleMenu() {
        if (this.isAnimating) return;
        this.isOpen ? this.closeMenu() : this.openMenu();
    }
    joinUsLinkRedirect(e) {
        let currentLocation = location.pathname.split("/");

        if (
            currentLocation[2] == "workplaces" &&
            currentLocation[3] != "slovakia"
        ) {
            this.scrollToJoinSection();
            return;
        }
        window.localStorage.setItem("scrollToJoin", "true");
        let targetLink = e.currentTarget.href;
        window.location.href = targetLink;
    }
    checkLocalStorageForScroll() {
        if ("scrollToJoin" in localStorage) {
            this.scrollToJoinSection();
            localStorage.clear();
        }
    }
    scrollToJoinSection() {
        const yOffset = -100;
        const element = document.getElementById("join");

        if (!element) return;
        const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
    }
    closeMenu() {
        let tl = new TimelineMax();
        this.isAnimating = true;
        this.isOpen = false;
        return tl

            .staggerFromTo(
                this.navItems,
                0.5,
                { x: 0, autoAlpha: 1 },
                {
                    x: 40,
                    autoAlpha: 0,
                    ease: Power3.easeInOut
                },
                0.05
            )
            .staggerTo(
                this.stripes,
                0.5,
                { scaleX: 0, ease: Power3.easeInOut },
                "-=0.4"
            )
            .set(this.element, {
                className: "-=header--open",
                onComplete: () => {
                    this.isAnimating = false;
                }
            });
    }

    openMenu() {
        let tl = new TimelineMax();
        this.isAnimating = true;
        this.isOpen = true;
        tl.set(this.element, { className: "+=header--open" })
            .staggerTo(
                this.stripes,
                0.5,
                { scaleX: 1, ease: Power3.easeInOut },
                0
            )
            .staggerFromTo(
                this.navItems,
                0.5,
                { x: 40 },
                {
                    x: 0,
                    autoAlpha: 1,
                    ease: Power3.easeInOut
                },
                0.05,
                "-=0.25",
                () => {
                    this.isAnimating = false;
                }
            );
    }
}
